import BaseClass from "../BaseClass";

// todo wird nur benötigt, wenn preview button vorhanden ist, muss im template noch abgefragt werden.
export default class Cta extends BaseClass {

    constructor(element) {

        super(element);
        this.$previewButton = null;
        this.url = null;

        this.$uiContainer = null;
        this.$videoContainer = null;

        this.loadVideoTemplateListener = null;
        this.previewEndedListener = null;

        this.init();
    }

    init() {

        const mySelf = this;

        const $previewButton = this.$element.find('[data-type=preview]');

        if ($previewButton != "undefined" && $previewButton.length > 0) {
            this.$previewButton = $previewButton;
        }

        if (this.$previewButton != null && this.$previewButton.length > 0) {
            this.url = this.$previewButton.attr('data-url');
        }

        this.$uiContainer = this.$element.find('[data-type="ui-container"]');
        this.$videoContainer = this.$element.find('[data-type="video-container"]');

        // load template
        this.loadVideoTemplateListener = function () {
            mySelf.loadVideoTemplate();
        }

        if (this.$previewButton != null) {
            this.$previewButton.on('click', this.loadVideoTemplateListener)
        }

        // preview ended
        this.previewEndedListener = function () {
            mySelf.display();
        }
        $(document).on('preview:ended', this.previewEndedListener);
    }

    /**
     * Template inkl. Player laden
     */
    loadVideoTemplate() {
        const mySelf = this;

        $(document).trigger('show:loading');

        let jqxhr = $.post(this.url, {}, function () {
        }, 'html')
            .done(function (response) {
                mySelf.$videoContainer.empty().html(response);
                mySelf.hide();
                $(document).trigger('content:loaded');
            })
            .fail(function (response) {
                // todo video konnte nicht abgespielt werden, Fehler anzeigen
            })
            .always(function () {
                $(document).trigger('hide:loading');
            });
    }

    /**
     * Cta einblenden (element behält dimensionen)
     */
    display() {
        this.$uiContainer.animate({'opacity': '1'});
        this.$videoContainer.empty();
    }

    /**
     * Cta ausblenden
     */
    hide() {
        this.$uiContainer.animate({'opacity': '0'});
    }

    destroyListener() {
        if (this.$previewButton != null && this.$previewButton != undefined) {
            this.$previewButton.off('click', this.loadVideoTemplateListener)
        }
        $(document).off('preview:ended', this.previewEndedListener);
    }
}
